var map = {
	"./about/index.vue": [
		6697,
		697
	],
	"./artist/index.vue": [
		4295,
		295
	],
	"./contact/index.vue": [
		5147,
		147
	],
	"./home/index.vue": [
		8752,
		752
	],
	"./news-detail/index.vue": [
		1298,
		298
	],
	"./news/index.vue": [
		2738,
		738
	],
	"./perform-detail/index.vue": [
		8926,
		926
	],
	"./perform/index.vue": [
		3806,
		806
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6278;
module.exports = webpackAsyncContext;